import AssetAssociationShow from '@/views/assetAssociations/show';

export default [
  {
    path: '/asset-association/:assetAssociationId',
    name: 'assetAssociation#show',
    component: AssetAssociationShow,
  },
];
